import React, { useCallback, useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { StateModel } from 'redux/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { colorsTheme } from 'resources/theme/styled/colors';
import { IApplication } from 'typings/application/applications';
import { applicationsAPI } from 'api/application/applicationsAPI';
import { setActiveApplication } from 'redux/actions/applications';

// components
import StepsCard, { Step } from 'components/Additional/StepsCard';
import { Text, AsyncButton, SectionIntro } from '@ui';

const StartOnboarding = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('onboarding');
  const activeApplication = useSelector<StateModel, IApplication | null>(
    (state) => state.applications.activeApplication,
  );

  const steps = useMemo<Step[]>(() => {
    return [
      {
        key: 'submitted',
        title: t('intake_form.submitted.title'),
        status: 'completed',
        disabled: true,
      },
      {
        key: 'under-review',
        title: t('intake_form.under_review.title'),
        status: 'completed',
        disabled: true,
      },
      {
        key: 'accepted',
        title: t('intake_form.accepted.title'),
        status: 'completed',
        disabled: true,
      },
    ];
  }, []);

  const handleStartOnboarding = useCallback(async () => {
    if (!activeApplication) {
      return;
    }
    await applicationsAPI.startOnboarding(activeApplication._id);
    dispatch(
      setActiveApplication({ ...activeApplication, isOnboardingStarted: true }),
    );
  }, [activeApplication]);

  return (
    <ContentWrapper>
      <StepsCard
        steps={steps}
        onSelect={console.log}
        activeStep="accepted"
        addOpacityToDisabledSteps={false}
      >
        <SectionIntro
          hideDivider
          titleColor={colorsTheme.colorWhite}
          title={t('intake_form.accepted.title')}
        />
        <TextWithTopMargin>
          {t('intake_form.accepted.description_line_1')}
        </TextWithTopMargin>
        <TextWithTopMargin>
          {t('intake_form.accepted.description_line_2')}
        </TextWithTopMargin>
        <StyledButton size="large" onClick={handleStartOnboarding}>
          {t('intake_form.accepted.button')}
        </StyledButton>
      </StepsCard>
    </ContentWrapper>
  );
};

const ContentWrapper = styled.div`
  padding-top: 64px;
  width: 75%;
  margin: 0 auto;

  @media screen and (max-width: ${({ theme }) => theme.hdScreen}) {
    width: 80%;
    max-width: 80%;
  }

  @media screen and (max-width: ${({ theme }) => theme.tabletScreen}) {
    width: 100%;
    max-width: 100%;
  }
`;

const TextWithTopMargin = styled(Text)`
  margin-top: ${({ theme }) => theme.marginMd};
`;

const StyledButton = styled(AsyncButton)`
  margin-top: ${({ theme }) => theme.marginMd};
`;

export default StartOnboarding;
